// addUser
// getAllUsers
// getUserById
// getUsersByResortId
// modifyUser
// deleteUser
// /api/userApi.js

import api from './api'

// resortId : le site vise par un super admin, l intercepteur garde l en-tete
export const addUser = async (user, resortId = null) => {
  const config = resortId
    ? { headers: { 'X-Resort-Id': String(resortId) } }
    : {}
  const response = await api.post('/users/Add', user, config)
  return response.data
}
export const getAllUsers = async () => {
  try {
    return await api.get(`/users`)
  } catch (err) {
    console.error('Error fetching all users:', err)
    throw err
  }
}

export const getUserById = async id => {
  try {
    const response = await api.get(`/users/user/${id}`)
    return response.data
  } catch (err) {
    console.error('err')
    throw err
  }
}

// get user email notification preference
export const getEmailNotificationPreference = async userId => {
  try {
    const response = await api.get(
      `/users/${userId}/email-notification-preference`,
    )
    return response.data
  } catch (err) {
    console.error('Error fetching email notification preference:', err)
    throw err
  }
}

// Update user email notification preference
export const updateEmailNotificationPreference = async (
  userId,
  emailNotificationsEnabled,
) => {
  try {
    const response = await api.put(
      `/users/${userId}/email-notification-preference`,
      { emailNotificationsEnabled },
    )
    return response.data
  } catch (err) {
    console.error('Error updating email notification preference:', err)
    throw err
  }
}

export const getUsersByResortId = async id => {
  try {
    return await api.get(`/users/userResort/${id}`)
  } catch (err) {
    console.error('err')
    throw err
  }
}
// resortId : le site vise par un super admin, l intercepteur garde l en-tete
export const modifyUser = async (id, user, resortId = null) => {
  try {
    const config = resortId
      ? { headers: { 'X-Resort-Id': String(resortId) } }
      : {}
    const response = await api.put(`/users/modifier/${id}`, user, config)
    return response.data
  } catch (err) {
    console.error('err')
    throw err
  }
}

export const deleteUser = async id => {
  try {
    return await api.delete(`/users/delete/${id}`)
  } catch (err) {
    console.err('err')
    throw err
  }
}

export const deactivateUserAccount = async id => {
  try {
    const response = await api.put(`/users/deactivate-account/${id}`)
    return response.data
  } catch (err) {
    console.error('Error deactivating user account:', err)
    throw err
  }
}

export const reactivateUserAccount = async id => {
  try {
    const response = await api.put(`/users/reactivate-account/${id}`)
    return response.data
  } catch (err) {
    console.error('Error reactivating user account:', err)
    throw err
  }
}

export const getActiveUsersByResortId = async id => {
  try {
    const response = await api.get(`/users/active-users/resort/${id}`)
    return response.data
  } catch (err) {
    console.error('Error fetching active users:', err)
    throw err
  }
}

export const getUserPermissions = async userId => {
  try {
    const response = await api.get(`/users/${userId}/permissions`)
    return response.data
  } catch (err) {
    console.error('Error fetching user permissions:', err)
    throw err
  }
}

export const updateUserPermissions = async (userId, permissionIds) => {
  try {
    const response = await api.put(`/users/${userId}/permissions`, {
      permissionIds,
    })
    return response.data
  } catch (err) {
    console.error('Error updating user permissions:', err)
    throw err
  }
}

// Sites rattaches a un compte (Super Admin uniquement).
// Pas de try/catch : le 409 du detachement porte le motif du refus, l avaler
// priverait l IHM de l explication a afficher.
// `me` est refuse (401) par l allowlist publique : toujours un id numerique.
export const getUserResorts = async userId =>
  await api.get(`/users/${userId}/resorts`)

export const attachUserResort = async (userId, resortId) =>
  await api.post(`/users/${userId}/resorts`, { resort_id: resortId })

export const detachUserResort = async (userId, resortId) =>
  await api.delete(`/users/${userId}/resorts/${resortId}`)

// Email change verification flow
export const requestEmailChange = async userId => {
  try {
    const response = await api.post('/users/requestEmailChange', {
      userId,
    })
    return response.data
  } catch (err) {
    console.error('Error requesting email change:', err)
    throw err
  }
}

export const verifyEmailCode = async (userId, code) => {
  try {
    const response = await api.post('/users/verifyEmailCode', {
      userId,
      code,
    })
    return response.data
  } catch (err) {
    console.error('Error verifying email code:', err)
    throw err
  }
}

export const changeEmail = async (userId, code, newEmail) => {
  try {
    const response = await api.post('/users/changeEmail', {
      userId,
      code,
      newEmail,
    })
    return response.data
  } catch (err) {
    console.error('Error changing email:', err)
    throw err
  }
}
